import { JSX } from 'react';

import * as styles from './DataTableColumnsListItem.sty.js';
import { Checkbox } from '../../../../../forms/checkbox/Checkbox.js';
import { getColumnLabel } from '../../../../utils/get-column-label.js';
import type { Column } from '../../../hooks/useTable/types.js';

interface ColumnVisibilityCheckboxProps {
  /**
   * The column to render the checkbox for.
   */
  column: Column<unknown, unknown>;
  /**
   * Whether visibility can be changed for this column.
   */
  enableCheckbox: boolean;
  /**
   * The current visibility state of the column.
   */
  currentState: boolean | 'indeterminate';
  /**
   * Callback when the checkbox is clicked and visibility of the column changes.
   */
  onVisibilityChange: (
    column: Column<unknown, unknown>,
    currentVisibility: boolean | 'indeterminate',
  ) => void;
}

/**
 * Checkbox component for toggling column visibility in the DataTable column settings.
 * @internal
 */
export const ColumnVisibilityCheckbox = (
  props: ColumnVisibilityCheckboxProps,
): JSX.Element => {
  const { column, enableCheckbox, currentState, onVisibilityChange } = props;

  const columnName = getColumnLabel(column);
  const dataDtProperties = `state:${currentState === true ? 'hide' : 'show'}`;

  return (
    <Checkbox
      value={currentState}
      aria-disabled={!enableCheckbox}
      onChange={() => {
        if (enableCheckbox) {
          onVisibilityChange(column, currentState);
        }
      }}
      className={styles.columnName}
      data-dt-name="ColumnSettingsShowHideColumn"
      data-dt-properties={dataDtProperties}
    >
      {columnName}
    </Checkbox>
  );
};
